import {requireImage} from './utils';

const getDefaultLogo = (): string => requireImage('techsee_logo.png');
const ABSOLUTE_PATTERN = /^(\/\/|\/|https?:|data:)/;

/**
 * Normalizes a logo URL to be root-relative. Leaves absolute URLs (http, https, data, //, /) unchanged.
 */
export function normalizeLogoUrl(url: string | undefined): string {
    if (!url) return '';
    const trimmed = String(url).trim();
    if (ABSOLUTE_PATTERN.test(trimmed)) return trimmed;
    return '/' + trimmed.replace(/^\/*/, '');
}

/**
 * Resolves logo URL with fallback to default TechSee logo when empty.
 */
export function resolveLogoUrl(url: string | undefined): string {
    return normalizeLogoUrl(url) || getDefaultLogo();
}
